import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ICardLayout } from '../../types/layout/card';
import { formFieldLayoutsSelector, formFieldsSelector } from '../../redux/selectors/forms';
import { LayoutContext } from '../../contexts/layout';
import { commentariesListSelector } from '../../redux/selectors/commentaries';

function CardTitle({ commentariesCount, dynamicTitle, title }: ICardLayout) {
    const [dynamicTitleStr, setDynamicTitleStr] = useState('');

    const { layoutId } = useContext(LayoutContext);

    const commentariesList = useSelector(commentariesListSelector(commentariesCount));
    const dependingFieldsValues = useSelector(formFieldsSelector(layoutId, dynamicTitle?.dependingFields));
    const fieldLayouts = useSelector(formFieldLayoutsSelector(layoutId));

    const processDynamicTitle = () => {
        if (dynamicTitle?.from === 'form') {
            const dependingStrings = {} as Record<string, string|number|undefined>;

            if (Object.keys(dependingFieldsValues).length > 0) {
                dynamicTitle.dependingFields.forEach((field) => {
                    const fieldLayout = fieldLayouts?.[field];
                    let value = dependingFieldsValues[field];

                    if (fieldLayout?.type === 'select') {
                        value = Array.isArray(fieldLayout.data) ? fieldLayout.data.find((el) => el.value === value)?.label : undefined;
                    }

                    if (fieldLayout?.type === 'multiple-select' && Array.isArray(fieldLayout.data) && Array.isArray(value)) {
                        const labels = fieldLayout.data.filter((el) => value.includes(el.value)).map((el) => el.label);
                        value = labels.join(', ');
                    }

                    if (['string', 'number'].includes(typeof value)) {
                        dependingStrings[field] = value;
                    }
                });
            }

            if (Object.keys(dependingStrings).length === dynamicTitle.dependingFields.length) {
                let nextDynamicTitleStr = dynamicTitle.mask;
                Object.keys(dependingStrings).forEach((field) => {
                    nextDynamicTitleStr = nextDynamicTitleStr.replace(`{${field}}`, dependingStrings[field] as string);
                });
                setDynamicTitleStr(nextDynamicTitleStr);
            } else {
                setDynamicTitleStr('');
            }
        }
    };

    const effectDependingFieldsLayoutData = () => {
        if (dynamicTitle && dynamicTitle.dependingFields.length > 0 && Object.values(dependingFieldsValues).length > 0) {
            const dependings: string[] = [];
            dynamicTitle.dependingFields.forEach((fieldName) => {
                const fieldLayout = fieldLayouts?.[fieldName];
                if (fieldLayout?.type === 'select') {
                    const labels = fieldLayout.data?.map((option) => option.label) || [];
                    dependings.push(...labels);
                }
            });
            return dependings.join(',');
        }
        return '';
    };

    useEffect(() => {
        processDynamicTitle();
    }, [Object.values(dependingFieldsValues).join(','), effectDependingFieldsLayoutData()]);

    let finalTitle = typeof dynamicTitle !== 'undefined' && dynamicTitleStr ? dynamicTitleStr : title;

    if (commentariesList.length) {
        finalTitle += ` (${commentariesList.length})`;
    }

    return (
        <h3 className="card-title">{finalTitle}</h3>
    );
}

export default CardTitle;
